import { CODE_BLOCK_REGEX, PARSE_CODE_BLOCK_REGEX } from 'chatspot-core/messages/code/CodeRegex';
import { useMemo } from 'react';
import styled from 'styled-components';
import CodeBlock from '../../components/text/CodeBlock';
import Markdown from '../../components/text/Markdown';
import { jsx as _jsx } from "react/jsx-runtime";
const MessageWrapper = styled.div.withConfig({
  displayName: "HtmlSectionFormatter__MessageWrapper"
})(["width:100%;"]);
const HtmlSectionFormatter = ({
  section: {
    text = ''
  }
}) => {
  const messageBlocks = useMemo(() => {
    const textBlocks = text.split(CODE_BLOCK_REGEX);
    return textBlocks.map((textBlock, index) => {
      const parsedCodeBlock = textBlock.match(PARSE_CODE_BLOCK_REGEX);
      if (parsedCodeBlock) {
        const [__fullTextBlock, language, code] = parsedCodeBlock;
        return /*#__PURE__*/_jsx(CodeBlock, {
          code: code,
          language: language
        }, index);
      }
      return /*#__PURE__*/_jsx(Markdown, {
        html: textBlock
      }, index);
    });
  }, [text]);
  return /*#__PURE__*/_jsx(MessageWrapper, {
    children: messageBlocks
  });
};
export default HtmlSectionFormatter;